import { asyncRoutes, constantRoutes } from '@/router';
import EnumResource from '@/api/tool/enum.js';
import store from '@/store';
import { getSupportChannelTypes } from '@/tools';

const enumResource = new EnumResource();
const state = {
  routes: [],
  addRoutes: [],
};

const _menu = [];
const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }, { roles, permissions }) {
    return new Promise(async(resolve) => {
      let accessedRoutes;
      if (roles.includes('admin')) {
        accessedRoutes = asyncRoutes;
      } else {
        resetPermissionRouter(permissions.menu);
        resetNowRouter(asyncRoutes);
        accessedRoutes = asyncRoutes;
      }
      commit('SET_ROUTES', accessedRoutes);
      const promises_map = getSupportChannelTypes().map(channel => {
        return [
          () => getChannelEnum(channel),
          (res) => store.dispatch('enum/setEnumValue', { value: res, channel }),
        ];
      });
      const values = await Promise.all(promises_map.map(([promise]) => promise()));
      promises_map.forEach(([_, handler], index) => handler(values[index]));
      resolve(accessedRoutes);
    });
  },
};

function resetPermissionRouter(list) {
  list.forEach(item => {
    _menu.push(item.menu_permission);
  });
}

function resetNowRouter(list) {
  list.forEach(item => {
    if (_menu.indexOf(item.meta.permissions) === -1) {
      item.hidden = true;
    }
    if (item.children) {
      resetNowRouter(item.children);
    }
  });
}

/**
 * 获取媒体枚举值
 * @param {String} type 媒体类型
 * @returns {Promise<Object>}
 */
function getChannelEnum(type) {
  return new Promise((resolve, reject) => {
    enumResource.getApi({ type, list: true }).then(response => {
      resolve(response.list);
    }).catch(reject);
  });
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
